<div class="drawer-content">
	<mat-nav-list>
		<mat-accordion>
			<mat-expansion-panel [expanded]="true">
				<mat-expansion-panel-header class="disable_ripple">
					<mat-panel-title>
						<mat-icon mat-list-icon>local_police</mat-icon>
						<div class="title pl-sm" mat-line> Claims</div>
					</mat-panel-title>
				</mat-expansion-panel-header>
				<mat-list-item routerLinkActive="active" routerLink="/claims/aia">
					<mat-icon mat-list-icon>local_police</mat-icon>
					<div class="title" mat-line>Claims - AIA</div>
				</mat-list-item>
				
				<mat-list-item routerLinkActive="active" routerLink="/claims/sompo">
					<mat-icon mat-list-icon>local_police</mat-icon>
					<div class="title" mat-line>Claims - Berjaya Sompo</div>
				</mat-list-item>

				<mat-list-item routerLinkActive="active" routerLink="/claims/tune-protect">
					<mat-icon mat-list-icon>local_police</mat-icon>
					<div class="title" mat-line>Claims - Tune Protect</div>
				</mat-list-item>
				<!-- <mat-list-item routerLinkActive="active" routerLink="/claims/tiktok-shop">
					<mat-icon mat-list-icon>local_police</mat-icon>
					<div class="title" mat-line>Claims - TikTok Shop</div>
				</mat-list-item> -->
			</mat-expansion-panel>
		</mat-accordion>
	</mat-nav-list>
</div>
